interface Font {
  name: string;
  family: string;
}

export const fonts: Font[] = [
  { name: 'FireSans', family: '--firesans' },
  { name: 'Jetbrains Mono', family: '--jetbrains-mono' },
  { name: 'Helevtica', family: '--helevtica' },
];
